import {
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  // LIST_TRANSACTIONS_IN_RANGE_REQ,
  GET_INVOICE_SETTINGS,
  LIST_INVOICES_IN_RANGE_REQ,
  ACTIVE_APPOINTMENT_DETAIL,
  GET_ME_REQ,
  GET_LOOKUPS_REQ,
  GET_CLIENT_RELATIONSHIP_REQUEST,
  LIST_CLIENTS_REQ,
  SEARCH_CLIENTS_REQ,
  LIST_ACTIVE_CLIENTS_REQ,
  LIST_GROUPS_REQ,
  INVOICE_REQ,
  CLIENT_PAGE_SIZE,
  CODE_SUGGESTIONS
} from '@/store/constants'

import axios from 'axios'
import debounce from '@/mixins/debounce'
import Vue from 'vue'
import * as Sentry from '@sentry/browser'

// const ACTION_RESOURCES = {
//   'practitioner.appointment': '/api/v3/practitioner/appointments/'
// }

export default {
  name: 'RequestsMixin',
  data () {
    return {
      requestTimeout: null,
      globalRequests: {
        appointmentsv2: {
          resource: 'ag.practitioner.appointments'
        }
      }
    }
  },
  computed: {
    getMeReq () {
      return this.$store.getters.getRequestById(GET_ME_REQ, true)
    },
    getMeReqStatus () {
      return this.getMeReq.status
    },
    getLookupsReq () {
      return this.$store.getters.getRequestById(GET_LOOKUPS_REQ, true)
    },
    globalDataLoading () {
      return this.getLookupsReq.loading || this.getMeReq.loading
    },
    getClientRelationship () {
      return this.$store.getters.getRequestById(GET_CLIENT_RELATIONSHIP_REQUEST, true)
    },
    getClientsReq () {
      return this.$store.getters.getRequestById(LIST_CLIENTS_REQ, true)
    },
    getClientsReqStatus () {
      return this.getClientsReq.status
    },
    getClientSearchReq () {
      return this.$store.getters.getRequestById(SEARCH_CLIENTS_REQ, true)
    },
    getClientSearchReqStatus () {
      return this.getClientSearchReq.status
    },
    getInvoiceSettingsRequest () {
      return this.$store.getters.getRequestById(GET_INVOICE_SETTINGS, false)
    },
    getInvoiceSettingsRequestStatus () {
      return this.getInvoiceSettingsRequest.status
    },
    getCachedCodeSuggestions () {
      let req = this.$store.getters.getRequestById(CODE_SUGGESTIONS, false)
      return this.getObjectPath(req, 'result.data.codes', [])
    },
    getAppointmentsInRangeRequest () {
      return this.$store.getters.getRequestById(LIST_APPOINTMENTS_IN_RANGE_REQ, false)
    },
    getAppointmentsInRangeRequestStatus () {
      return this.getAppointmentsInRangeRequest.status
    },
    getLookupsRequest () {
      return this.$store.getters.getRequestById(GET_LOOKUPS_REQ, false)
    },
    getLookupsRequestStatus () {
      return this.getLookupsRequest.status
    },
    globalInitRequestLoading () {
      return this.getLookupsRequest.loading || this.getMeReq.loading
    },
    globalAppointmentsV2RequestStatus () {
      if (this.globalRequests && this.globalRequests.appointmentsv2) {
        return this.globalRequests.appointmentsv2.status
      }
      return 0
    }
  },
  watch: {
    getClientsReqStatus () {
      if (this.getClientsReqStatus === 200) {
        let response = this.getObjectPath(this.getClientsReq, 'result.data', {})
        if (response.next) {
          let currentPage = this.getObjectPath(this.getClientsReq, 'params.page', 1)
          this.getClients(currentPage + 1, CLIENT_PAGE_SIZE)
        }
        this.updateClientDb(response)
      }
    },
    getClientSearchReqStatus () {
      if (this.getClientSearchReqStatus === 200) {
        let response = this.getObjectPath(this.getClientSearchReq, 'result.data', {})
        this.updateClientDb(response)
      }
    },
    getAppointmentsInRangeRequestStatus () {
      if (this.getAppointmentsInRangeRequestStatus === 200) {
        this.updateAppointmentDb()
      }
    },
    globalAppointmentsV2RequestStatus () {
      if (this.globalAppointmentsV2RequestStatus === 200) {
        let appts = this.getObjectPath(this.globalRequests.appointmentsv2, 'result.results', [])
        this.$store.commit('addAppointments', appts)
      }
    }
  },
  methods: {
    updateAppointmentDb: debounce(function () {
      let appts = this.getObjectPath(this.getAppointmentsInRangeRequest, 'result.data', [])
      this.$store.commit('addAppointments', appts)
    }, 1000),
    updateClientDb: debounce(function (response) {
      this.$store.commit('addManyClients', response.results)
    }, 500),
    reloadPage () {
      if (this.refreshRequestIds) {
        for (let reqId of this.refreshRequestIds) {
          this.$store.dispatch('RETRY', reqId)
        }
      }
    },
    async performAction (service, context, collection, id, action, data) {
      // bulk:
      let url = `${service.baseUrl}/api/v3/${context}/${collection}/actions/${action}/`
      if (id) { // instance
        url = `${service.baseUrl}/api/v3/${context}/${collection}/${id}/actions/${action}/`
      }
      let headers = service.headers
      let options = {
        url,
        headers,
        data,
        method: 'post'
      }
      return await axios(options)
    },
    async action (service, context, collection, id, action, data, response) {
      try {
        Vue.set(response, 'status', 0)
        Vue.set(response, 'loading', true)
        let result = await this.performAction(service, context, collection, id, action, data)
        if (result.status > 199) {
          Vue.set(response, 'status', result.status)
          Vue.set(response, 'loading', false)
          Vue.set(response, 'result', result.data)
        }
      } catch (error) {
        if (error.response) {
          Vue.set(response, 'status', error.response.status)
          Vue.set(response, 'loading', false)
          Vue.set(response, 'result', error.response.data)
        } else if (error.request) {
          Vue.set(response, 'loading', false)
          Vue.set(response, 'status', 500)
          Vue.set(response, 'result', {message: 'No response from the server'})
        } else {
          Vue.set(response, 'loading', false)
          Vue.set(response, 'status', 500)
          Vue.set(response, 'result', {message: 'Unable to make request'})
        }
      } finally {
        Vue.set(response, 'loading', false)
      }
    },
    performProcess (id, processName, practitionerId, appointmentId, payload) {
      let data = {
        'practitioner': practitionerId,
        'appointment': appointmentId,
        'name': processName,
        'request_data': JSON.stringify(payload)
      }
      this.$appointmentguru
        .resource('process')
        .id(id)
        .create(data)
    },
    getAppointment (id) {
      this.$appointmentguru
        .resource('practitioner.appointments')
        .id(ACTIVE_APPOINTMENT_DETAIL)
        .get(id)
    },
    getPractitionerAppointments (practitionerId, fromDate, toDate) {
      if (!fromDate) {
        fromDate = this.$store.state.application.activeDateRange.from
      }
      if (!toDate) {
        toDate = this.$store.state.application.activeDateRange.to
      }

      this.globalRequests.appointmentsv2.params = {}
      this.globalRequests.appointmentsv2.params.after_utc = fromDate
      this.globalRequests.appointmentsv2.params.before_utc = toDate
      this.globalRequests.appointmentsv2.params.page_size = 1000
      if (practitionerId) {
        this.globalRequests.appointmentsv2.params.practitioner = practitionerId
      }

      // Vue.set(this.calendars, this.practitioner.id, this.globalRequests.appointmentsv2)
      this.$request('get', this.globalRequests.appointmentsv2)
    },
    getAppointmentsInRange (params = {}, force = false) {
      let fromDate = this.$store.state.application.activeDateRange.from
      let toDate = this.$store.state.application.activeDateRange.to
      if (!params) { params = {} }
      params.after_utc = fromDate
      params.before_utc = toDate

      if (!this.getAppointmentsInRangeRequest.loading || force) {
        // params = Object.extend(defaultParams, params)
        this.$appointmentguru
          .resource('practitioner.appointments')
          .id(LIST_APPOINTMENTS_IN_RANGE_REQ)
          .list(params)
      } else {
        window.clearTimeout(this.requestTimeout)
        this.requestTimeout = window.setTimeout(() => {
          this.$appointmentguru
          .resource('practitioner.appointments')
          .id(LIST_APPOINTMENTS_IN_RANGE_REQ)
          .list(params)
        }, 2000)
      }
    },
    loadInvoices (dateType = 'due', initialParams) {
      let params = {
        // 'practitioner_id': this.me.id
        facets: 'practitioner_id,space_id'
      }
      if (initialParams) {
        params = Object.assign(params, initialParams)
      }
      let dateRange = this.$store.state.application.activeDateRange
      let fromDate = false
      let toDate = false
      Sentry.configureScope((scope) => {
        scope.setExtra('DateRange', dateRange)
      })
      if (dateRange && dateRange.from) {
        fromDate = dateRange.from
        if (fromDate.trim) { fromDate = fromDate.trim() }
      }
      if (dateRange && dateRange.to) {
        toDate = dateRange.to
        if (toDate.trim) { toDate = toDate.trim() }
      }
      if (dateType === 'due') {
        if (fromDate) { params['due_after_utc'] = fromDate }
        if (toDate) { params['due_before_utc'] = toDate }
      } else {
        if (fromDate) { params['after_utc'] = fromDate }
        if (toDate) { params['before_utc'] = toDate }
      }

      this.$invoiceguru
        .resource('invoices')
        .id(LIST_INVOICES_IN_RANGE_REQ)
        .list(params)

      // this.$invoiceguru
      //   .resource('transactions')
      //   .id(LIST_TRANSACTIONS_IN_RANGE_REQ)
      //   .list(params)
    },
    getInvoiceSettings () {
      this.$invoiceguru
        .resource('invoiceSettings')
        .id(GET_INVOICE_SETTINGS)
        .get()
    },
    init () {
      this.getMe()
      this.getLookups()
    },
    getMe () {
      this.$appointmentguru
        .resource('practitioner.me')
        .id(GET_ME_REQ)
        .list()
    },
    getLookups () {
      this.$appointmentguru
        .resource('practitioner.lookups')
        .id(GET_LOOKUPS_REQ)
        .list()
    },
    refreshGlobalSettings () {
      if (!this.globalDataLoading) {
        this.getMe()
        this.getLookups()
      }
    },
    getRemoteRelationship (id) {
      this.$appointmentguru
        .resource('practitioner.v3.relationships')
        .id(GET_CLIENT_RELATIONSHIP_REQUEST)
        .get(id)
    },
    getGroups () {
      this.$multiguru
        .resource('group.expanded')
        .id(LIST_GROUPS_REQ)
        .list()
    },
    getClients (page = 1, pageSize = CLIENT_PAGE_SIZE) {
      let params = {
        'page': page,
        'page_size': pageSize
      }
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(LIST_CLIENTS_REQ)
        .list(params)
    },
    getActiveClients () {
      let params = {
        from_date: this.globalActiveDateRange.from,
        to_date: this.globalActiveDateRange.to
      }
      this.$appointmentguru
        .resource('practitioner.v3.clients.active')
        .id(LIST_ACTIVE_CLIENTS_REQ)
        .list(params)
    },
    searchClients (searchString) {
      let params = {
        'search': searchString
      }
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(SEARCH_CLIENTS_REQ)
        .list(params)
    },
    getInvoice (id) {
      let reqId = INVOICE_REQ(id)
      this.$invoiceguru
        .resource('invoices')
        .id(reqId)
        .get(id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requests.js